import ReactDOM from 'react-dom';
import IPortalProps from './PortalProps';

const Portal = ({ selector, children }: IPortalProps) => {
  const element = document.querySelector(selector);

  if (element !== null) {
    return ReactDOM.createPortal(children, element);
  } else {
    return null;
  }
};

Portal.defaultProps = {
  selector: 'body',
};

export default Portal;
